export function formatVND(value: number | string) {
  if (!value) return "0₫";

  const number = Number(value);

  if (isNaN(number)) return "Liên hệ";
  if (number === 0) return "Liên hệ";

  return number.toLocaleString("vi-VN") + "₫";
}
